module.exports = __webpack_public_path__ + "img/360NoDevice.2de91bc2.svg";